"use strict";
import jsDiff from "./js_diff";
export default {
  diff: function(one, other) {
    var diff = jsDiff.diffChars(one, other);
    var ret = "";
    diff.forEach(function(part) {
      if (part.added) {
        ret += "<b>" + part.value + "</b>";
      } else if (part.removed) {
      } else {
        ret += part.value;
      }
    });
    return ret;
  }
};
